import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=68405f6d&"
import script from "./FlagIcon.vue?vue&type=script&lang=ts&"
export * from "./FlagIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports